<template lang="pug">
div.col-md-10.col-sm-12(style="margin:0 auto")
        form-insert(v-if="IsShowModalInsert" :IsShowModal.sync="IsShowModalInsert",:nameModulo="nameModulo",:parameter.sync="parameterInsert", @sendInfo="val => Insert(val)")
        form-update(v-if="IsShowModalUpdate" :IsShowModal.sync="IsShowModalUpdate",:nameModulo="nameModulo",:parameter.sync="parameterUpdate", @sendInfo="val => Update(val)")
        form-access-document(:IsShowModal.sync="IsShowModalAccessDocument",:ItemSelect.sync="ItemSelect")
        form-access-link(:IsShowModal.sync="IsShowModalAccessLink",:ItemSelect.sync="ItemSelectLink")
        form-reset-password(:IsShowModal.sync="isShowModalChangePassword",:nameModulo="nameModulo",:parameter.sync="parameterResetPassword", @sendInfo="val => Reset(val)")
        .card.bg-menu.text-white.form-group.col-md-4.col-sm-12(v-if="IsShowEnterprise")
            .card-body  
                label Selecion de Empresa {{IsShowEnterprise}} 
                select.form-control.form-control-sm(v-if="tableEnterprise", v-model="selectEnterprise",@change="setEnterprise()")
                    option(v-for="(item,index) in tableEnterprise", :value="item.IdEnterprise") {{item.BusinessName}} 
        .card
            .card-header.bg-menu.text-white
                .card-title
                    .form-row
                        .col-md-9.col-sm-12
                            h4 Mantenedor {{nameModulo}} {{ selectEnterprise }}
                        .col-md-3.col-sm-12.text-right
                            button.btn.btn-sm.btn-primary.text-light(@click="IsShowModalInsert=true") Crear {{nameModulo}} 
                                i.fa.fa-plus-circle
            form-view(:parameter.sync="parameterView",:tablaInfo.sync="tableInfo", @sendSearch="val => List_Info(val)", @sendInfo="val => {IsShowModalUpdate=true,parameterUpdate=val}",@sendChangePassword="val=> {isShowModalChangePassword=true,parameterResetPassword.IdUser=val.IdUser }",@sendInfoAccessDocument="val => {IsShowModalAccessDocument=true,ItemSelect=val}"  ,@sendInfoAccessLink="val => {IsShowModalAccessLink=true,ItemSelectLink=val}") 

</template>
<script> 
import apiWeb from "../../api/apiSLC.js"
import model from "../../models/users.js"
import modal from "../../complementos/modal.vue"
import modelEnterprise from "../../models/enterprise.js"
import modelDivision from "../../models/division.js"
import formInsert from './components/insert.vue'
import formUpdate from './components/update.vue'
import formView from './components/view.vue'
import formAccessDocument from './components/AccessDocument.vue'
import formAccessLink from './components/AccessLink.vue'
import formResetPassword from './components/resetPassword.vue'
import SHA3 from 'crypto-js/sha512';

export default {
    components:{
                formInsert,
                formUpdate,
                formView,
                formResetPassword,
                formAccessDocument,
                formAccessLink,
                modal
    },
    data(){
        return{
                nameModulo:'Usuario',
                pathApi:'users/users',
                pathApiD:'division/division',
                selectEnterprise:'0',
               // selecDivision:'0',
                selectUser:'0',
                tableEnterprise:[],
                tabletDivision:[],
                ItemSelect:{},
                ItemSelectLink:{},
                IsShowModalAccessDocument:false,
                IsShowModalAccessLink:false,
                IsShowModalInsert:false,
                IsShowModalUpdate:false,
                parameterUpdate:Object.assign({}, model.parameterUpdate),
                parameterInsert:Object.assign({}, model.parameterInsert),
                parameterView:Object.assign({}, model.parameterView),
                parameterDivision:Object.assign({}, model.parameterDivision),
                parameterResetPassword:Object.assign({}, model.parameterResetPassword),
                tableInfo:[],
                IsShowEnterprise:true,
                isShowModalChangePassword:false
        }
    },
    mounted(){ 
        if(this.$info.idEnterprise==1 && this.$info.typeAccount==4){
            this.List_Enterprise()
            this.IsShowEnterprise=true
        }
        else{
            this.IsShowEnterprise=false
            this.selectEnterprise=this.$info.idEnterprise
        }
        this.setEnterprise() 
              
    },
    methods:{        
        List_Enterprise(){
            apiWeb.post("Enterprise/Enterprise_View",{ RUT:'',BusinessName:'',Active:'1'})
                    .then(result=>{
                                if(result.status==0){ 
                                    console.log("Mensaje  ",result.value )
                                    this.tableEnterprise=JSON.parse(result.value)
                                    
                                    if(this.selectEnterprise=='' && this.tableEnterprise.length>0)
                                        this.selectEnterprise=this.tableEnterprise[0].IdEnterprise
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
       
        // List_Division(){
        //     apiWeb.post("division/division_View",{DivisionName:'',Active:'1'})
        //     .then(result=>{
        //         if(result.status==0){
        //             this.tabletDivision=JSON.parse(result.value)
        //             if(this.selecDivision=='' && this.tabletDivision.length>0)
        //                 this.selecDivision=this.tabletDivision[0].IdDivision
        //         }
        //         else{
        //                             this.$msgbox.show(result.message,"Error nivel 1")
        //                         }
        //     })
        //     .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        // }, 
        setEnterprise(){            
            this.parameterView.IdEnterprise=this.selectEnterprise
            this.parameterInsert.IdEnterprise=this.selectEnterprise
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
          //  this.parameterView.IdDivision=this.selecDivision
          //  this.parameterInsert.IdDivision=this.selecDivision
          //  this.parameterUpdate.IdDivision=this.selecDivision
             this.List_Info()
             this.List_Division()
             
        },
        List_Info(){
            this.parameterView.IdEnterprise=this.selectEnterprise
         //   this.parameterView.IdDivision=this.selecDivision
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Insert(){
            this.parameterInsert.IdEnterprise=this.selectEnterprise
         //   this.parameterInsert.IdDivision=this.selecDivision
            this.parameterInsert.User=this.$info.email
            this.parameterInsert.IP=this.$info.ip
            if(this.parameterInsert.IdEnterprise!=7){
                this.parameterInsert.IdDivision=-1
            }
            this.parameterInsert.Password=SHA3(this.parameterInsert.Password).toString()
            apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                    .then(result=>{ 
                            if(result.status==0){
                                this.List_Info()
                                this.IsShowModalInsert=false
                                this.parameterInsert=Object.assign({}, model.parameterInsert)
                                this.parameterInsert.IdEnterprise=this.selectEnterprise
                               // this.parameterInsert.IdDivision=this.selecDivision
                                this.$msgbox.show("Ingresado","Notificacion")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }

                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Update(){
            this.parameterUpdate.IdEnterprise=this.selectEnterprise
         //   this.parameterUpdate.IdDivision=this.selecDivision
            this.parameterUpdate.User=this.$info.email
            this.parameterUpdate.IP=this.$info.ip
            if(this.parameterUpdate.IdEnterprise!=7){
                this.parameterUpdate.IdDivision=-1
            }
            apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                    .then(result=>{ 
                             if(result.status==0){
                                this.List_Info()
                                this.IsShowModalUpdate=false
                                this.parameterUpdate.IdEnterprise=this.selectEnterprise
                               // this.parameterUpdate.IdDivision=this.selecDivision
                                this.$msgbox.show("Actualizado","Notificacion")
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Reset(){ 
            this.parameterResetPassword.User=this.$info.email
            this.parameterResetPassword.IP=this.$info.ip
            this.parameterResetPassword.NewPassword=SHA3(this.parameterResetPassword.NewPassword).toString()
            apiWeb.post(this.pathApi + "_Reset",this.parameterResetPassword)
                    .then(result=>{ 
                             if(result.status==0){
                                this.List_Info()
                                this.isShowModalChangePassword=false
                                this.$msgbox.show("Password Cambiada","Notificacion")
                            }
                            else{
                               this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
    }
}
</script>